import { Signal } from "../core/Signal.js";

export class History {

    public onHashChange = Signal.create<[string]>();

    private _hashDispatched: string = "";

    constructor() {
        this.init();
    }

    private init(): void {
        window.addEventListener("hashchange", () => this.handleHashChange());
    }

    private handleHashChange(): void {
        var newHash: string = window.location.hash;
        newHash = newHash.substring(1);

        var changed = newHash != this._hashDispatched;
        this._hashDispatched = newHash;
        this.setHash(newHash);
        if (changed)
            this.onHashChange.dispatch(this._hashDispatched);
    }

    public getHash(): string {
        return window.location.hash.substring(1);
    }

    public setHash(value: string, replace: boolean = false): void {
        if (this.getHash() == value) {
            return;
        }

        if (replace) {
            history.replaceState(undefined, undefined, "#" + value);
        } else {
            window.location.hash = "#" + value;
        }
    }

    public clear(replace: boolean = false): void {
        if (replace) {
            history.replaceState(undefined, undefined, "#");
        } else {
            window.location.hash = null;
        }
    }
}